export default __webpack_public_path__ + "static/media/check-mark.707c89ce.svg";